module.exports = __webpack_public_path__ + "static/media/rainDay.7df34fc1.png";